























































import Moment from "moment";
import { Component, Mixins } from "vue-property-decorator";
import { CommonTabMixin } from "./mixins";
import { ReceptionOperation } from "../../../../domain/workflow/items";
import { DocumentSummary } from "../../../../domain/document";

@Component
export default class DetailHistoryTab extends Mixins(CommonTabMixin) {

  // 文書参照
  async showDocument(row: ReceptionOperation): Promise<void> {

    try {
      // TODO: 現状では参照不可の文書でここに到達することは無いようだが、isReadableの判定もしておいたほうがよい？
      const result = await this.isConfirmedReadable(this.document);
      if (!result) { return; }
      await this.checkLogin(this.document);
      await this.checkWriteAuditLog(this.document);

      const param: any = {
        patientNo: this.reception.patientInfo.patient.id,
        documentId: this.document.id,
        archiveId: row.documentArchive.archiveId,
        isReadRestrictionAlreadyHandled: true.toString(),
      };

      this.$openWindow("/ShowDocument", param);

    } catch (e) {
      // confirm で いいえを押すと飛んでくる？
    }
  }

  async checkLogin(document: DocumentSummary): Promise<void> {
    if (this.documentShuoldLogin(document)) {
      await this.$commonDialogs.authentication.authenticator.show();
    }
  }

  toDateString(source: Date): string {
    return Moment(source).format("YY/MM/DD");
  }

  toTimeString(source: Date): string {
    return Moment(source).format("HH:mm");
  }

  get isReadableDocument(): boolean {
    return !!this.document && this.document.isReadable;
  }
}
